import { Link } from "react-router-dom";
import { seekerHero, seekerFeatures } from "../content/seeker";
import { categoryContrasts } from "../content/shared";
import { useMarketingAuthUi } from "../MarketingAuthUi";

export default function ForSeekers() {
  const { openRegister } = useMarketingAuthUi();

  return (
    <article className="mkt-page">
      <header className="mkt-hero">
        <h1>{seekerHero.title}</h1>
        <p>{seekerHero.subtitle}</p>
        <div className="mkt-cta-row">
          <button
            type="button"
            className="mkt-btn mkt-btn--primary"
            onClick={openRegister}
          >
            Create account
          </button>
          <Link className="mkt-btn mkt-btn--ghost" to="/how-it-works">
            How it works
          </Link>
        </div>
      </header>

      <section className="mkt-section">
        <h2>What you get</h2>
        <ul className="mkt-feature-list">
          {seekerFeatures.map((f) => (
            <li key={f.title}>
              <h3>{f.title}</h3>
              <p>{f.body}</p>
            </li>
          ))}
        </ul>
      </section>

      <section className="mkt-section">
        <h2>A different kind of career platform</h2>
        <ul className="mkt-contrast-list">
          {categoryContrasts.map((c) => (
            <li key={c.oldWay}>
              <div className="mkt-contrast__old">{c.oldWay}</div>
              <div className="mkt-contrast__new">{c.ourWay}</div>
            </li>
          ))}
        </ul>
      </section>
    </article>
  );
}
